import { useLayoutEffect, useRef } from 'react';

import { ContextMenuProps } from '@app/utils/epgUtils';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Button } from '@mui/material';

interface ContexMenuComponentProps {
  open: boolean;
  handleChangeContextMenuProps(contextMenuProps: ContextMenuProps | null): void;
  contextMenuProps: ContextMenuProps;
  deleteRow(): void;
}

export const ContextMenu = ({
  open,
  contextMenuProps,
  handleChangeContextMenuProps,
  deleteRow,
}: ContexMenuComponentProps) => {
  const menuRef = useRef<HTMLMenuElement | null>(null);

  useLayoutEffect(() => {
    if (!open) return;

    function onClick(event: MouseEvent) {
      if (event.target instanceof Node && menuRef.current?.contains(event.target)) {
        return;
      }
      handleChangeContextMenuProps(null);
    }

    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
    };
  }, [open, handleChangeContextMenuProps]);

  return (
    <div
      // @ts-ignore
      ref={menuRef}
      style={{
        padding: 8,
        backgroundColor: '#fff',
        position: 'absolute',
        top: contextMenuProps.top,
        left: contextMenuProps.left,
        border: '1px solid rgba(0,0,0,0.1)',
      }}>
      <Button startIcon={<DeleteIcon />} size="small" variant="contained" onClick={deleteRow} data-cy="delete-row">
        Delete row
      </Button>
    </div>
  );
};
